export default "__VITE_ASSET__02jPOmK2__"